import { Fragment, useEffect, useRef, useState } from "react";
import { cn } from "@/libs/utils";
import { useTrans } from "src/utils/useTrans";
import { Color } from "src/constants/Color";
import { Portal } from "src/components/portal/Portal";
import DropDownIcon from "src/assets/icons/DropDownIcon";

type Props = {
  className?: string;
  children?: any;
  borderColor?: string;
  label?: string;
  icon?: any;
  disabled?: boolean;
};

const DropdownAlt = ({
  disabled = false,
  borderColor,
  className = "",
  children,
  label = "Download",
}: Props) => {
  const { t } = useTrans(["gnb"]);
  const ref = useRef<any>(null);
  const childRef = useRef<any>(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    window.addEventListener("blur", handleBlur);
    return () => {
      window.removeEventListener("blur", handleBlur);
    };
  }, []);

  const handleBlur = (e: any) => {
    setOpen(false);
  };

  return (
    <Fragment>
      {open && (
        <Portal
          className={"absolute left-0 top-full w-full"}
          onClickOutside={() => setOpen(false)}
          ref={childRef}
          container={ref.current}
        >
          <div>
            <div
              onClick={() => {
                setOpen(!open);
              }}
              style={{ borderColor: borderColor || Color.Black }}
              ref={childRef}
              className={cn(
                `left-0 -m-px mt-2.5 box-content w-full bg-white`,
                className,
              )}
            >
              {children}
            </div>
          </div>
        </Portal>
      )}
      <button
        onClick={(e) => {
          e.stopPropagation();
          setOpen(!open);
        }}
        ref={ref}
        style={{ borderColor: borderColor || Color.Black }}
        className={cn(
          "relative flex items-center justify-between rounded-md border px-3.5 py-5",
          className,
          { "pointer-events-none": disabled },
        )}
      >
        <span className="text-sm">{t(label)}</span>
        <div
          className={cn("transition-all duration-500", {
            "rotate-180": open,
            hidden: disabled,
          })}
        >
          <DropDownIcon />
        </div>
      </button>
    </Fragment>
  );
};

export default DropdownAlt;
